import React from "react";
import "./Header.scss";
import {BACKEND_ENABLED} from "./config";
import {isAnaglyphEnabled, isFullscreen, onFullscreenChange, toggleAnaglyph, toggleFullscreen} from "./DisplayModes";

export class Header extends React.Component<any, any> {
    private unsubscribeFullscreen: (() => void) | null = null;

    constructor(props: any) {
        super(props);
        this.state = {anaglyph: isAnaglyphEnabled(), fullscreen: isFullscreen()};
    }

    componentDidMount() {
        this.unsubscribeFullscreen = onFullscreenChange(() => this.setState({fullscreen: isFullscreen()}));
    }

    componentWillUnmount() {
        this.unsubscribeFullscreen?.();
    }

    fullscreenClicked = () => {
        toggleFullscreen();
    };

    anaglyphClicked = () => {
        this.setState({anaglyph: toggleAnaglyph()});
    };

    render() {
        return <div id="header-wrapper">
            <div className="header-top">
                <div id="header">
                    <div className="header-shade">
                    </div>
                </div>
                <div id="header-logo"></div>
            </div>
            <div id="system-message"></div>
            <div id="menu">
                <div id="menu-buttons">
                    <div className="menu-button fullscreen-button" role="button" onClick={this.fullscreenClicked}>
                        Fullscreen
                    </div>
                    <div className={"menu-button single-button" + (this.props.singleDisabled ? " disabled" : "")}
                         role="button" aria-disabled={!!this.props.singleDisabled}
                         title={this.props.singleDisabled ? "Not available during an online frame" : "Single player practice: start a new practice frame on your own"}
                         onClick={() => { if (!this.props.singleDisabled) this.props.onSingle?.(); }}>
                        Single Mode (practice)
                    </div>
                    <div className={"menu-button ruleset-button" + (this.props.rulesetDisabled ? " disabled" : "")}
                         role="button" id="btn-ruleset" aria-disabled={!!this.props.rulesetDisabled} data-ruleset={this.props.ruleset}
                         title={this.props.rulesetDisabled ? "Not available during an online frame or while looking for an opponent" : "Rules for practice and Find match: click to switch between Any ball and Snooker"}
                         onClick={() => { if (!this.props.rulesetDisabled) this.props.onRuleset?.(); }}>
                        Rules: {this.props.ruleset === "snooker" ? "Snooker" : "Any ball"}
                    </div>
                    <div className={"menu-button anaglyph-button" + (this.state.anaglyph ? " active" : "")}
                         role="button" aria-pressed={this.state.anaglyph} onClick={this.anaglyphClicked}>
                        Anaglyph 3D{this.state.anaglyph ? " (on)" : ""}
                    </div>
                    <div className="menu-button settings-button" role="button" title="Mouse sensitivity for aiming and for the cue stroke (shortcut: O)"
                         aria-keyshortcuts="O" onClick={() => this.props.onSettings?.()}>
                        Settings <kbd className="shortcut">O</kbd>
                    </div>
                    {BACKEND_ENABLED &&
                    <div className="menu-button multiplayer-button" role="button" title="Play an online frame against another player"
                         onClick={() => this.props.onMultiplayer?.()}>
                        Multiplayer
                    </div>}
                </div>
            </div>
        </div>
    }
}